import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { CountryPhone, COUNTRIES_PHONES_JSON_URL } from './phone-input.models';

@Injectable({ providedIn: 'root' })
export class CountriesPhoneService {
  private readonly http = inject(HttpClient);
  private cache$: Observable<CountryPhone[]> | null = null;

  getCountries(): Observable<CountryPhone[]> {
    if (!this.cache$) {
      this.cache$ = this.http.get<CountryPhone[]>(COUNTRIES_PHONES_JSON_URL).pipe(
        shareReplay(1),
        catchError(() => of([])),
      );
    }
    return this.cache$;
  }
}
